import { DateTime } from 'luxon';
import type { ModuleTransformer } from '../types';
import type { WeeklyOccurrenceFormType } from './WeeklyOccurrenceForm';

export const fromPayload: ModuleTransformer<WeeklyOccurrenceFormType>['fromPayload'] = ({
  lottery,
}) => {
  const {
    occurrence: { startDate, endDate },
  } = lottery;

  // Set default value for number of weeks to be able to handle COPY mode
  // where start and end date are reset to empty strings
  let numberOfWeeks = 1;
  if (endDate && startDate) {
    const numberOfDays =
      DateTime.fromISO(endDate).diff(DateTime.fromISO(startDate), 'days').days + 1;
    numberOfWeeks = Math.round(numberOfDays / 7);
  }

  return {
    startDate: lottery.occurrence.startDate,
    numberOfWeeks: numberOfWeeks,
    drawDay: lottery.drawDay,
    drawTime: lottery.drawTime,
  };
};
